import { z } from 'zod'
import { propertyTitleParamsSchema } from './data'
import { widgetSchema } from '../../common/schema'

export const propertyTitleWidgetConfig = widgetSchema.extend({
  filter: propertyTitleParamsSchema,
  tag: z.enum(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span']).default('h1').describe('HTML tag to render the title'),
  textAlign: z.enum(['left', 'center', 'right']).default('left').describe('Text alignment'),
  showLocation: z.boolean().default(false).describe('Show the property city below the title (WP PropertyMeta parity)'),
  showType: z.boolean().default(false).describe('Show the property type below the title (WP PropertyMeta parity)'),
  showRating: z.boolean().default(false).describe('Show the review rating and count below the title when available'),
  lightModeColors: z.object({
    accent: z.string().default('#f59e0c').describe('Accent color'),
    textColor: z.string().default('#111111').describe('Title text color'),
  }).default({ accent: '#f59e0c', textColor: '#111111' }).describe('Colors in light mode'),
  darkModeColors: z.object({
    accent: z.string().default('#f59e0c').describe('Accent color'),
    textColor: z.string().default('#f0f0f0').describe('Title text color'),
  }).default({ accent: '#f59e0c', textColor: '#f0f0f0' }).describe('Colors in dark mode'),
})

export type PropertyTitleWidgetConfig = z.infer<typeof propertyTitleWidgetConfig>
